import { render, staticRenderFns } from "./BZFunProject.vue?vue&type=template&id=2dbb2540&scoped=true"
import script from "./BZFunProject.vue?vue&type=script&lang=js"
export * from "./BZFunProject.vue?vue&type=script&lang=js"
import style0 from "./BZFunProject.vue?vue&type=style&index=0&id=2dbb2540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb2540",
  null
  
)

export default component.exports